import { WidgetLayout } from '@gsc/types'
import baseStyles from './base.less'
import flybyStyles from './flyby.less'
import barStyles from './bar.less'
import panelStyles from './panel.less'
import modalStyles from './modal.less'
import fullscreenStyles from './fullscreen.less'
import sidebarStyles from './sidebar.less'
import inlineStyles from './inline.less'

interface StyleFlags {
  big: boolean
  horizontal: boolean
  inline: boolean
}

const LayoutStyleMap: { [key in WidgetLayout]: StyleTemplate } = {
  [WidgetLayout.Flyby]: flybyStyles,
  [WidgetLayout.Bar]: barStyles,
  [WidgetLayout.Panel]: panelStyles,
  [WidgetLayout.Modal]: modalStyles,
  [WidgetLayout.Fullscreen]: fullscreenStyles,
  [WidgetLayout.Sidebar]: sidebarStyles,
  [WidgetLayout.Inline]: inlineStyles,
}

function getLayoutStyles(layout: WidgetLayout): StyleTemplate {
  return LayoutStyleMap[layout] || (() => '')
}

function getStyleFlags(layout: WidgetLayout, inline: boolean): StyleFlags {
  const flags: StyleFlags = {
    big: false,
    horizontal: false,
    inline,
  }

  switch (layout) {
    case WidgetLayout.Bar:
      return { ...flags, horizontal: true }

    case WidgetLayout.Modal:
    case WidgetLayout.Fullscreen:
    case WidgetLayout.Sidebar:
    case WidgetLayout.Inline:
      return { ...flags, big: true }

    default:
      return flags
  }
}

export function renderStyles(layout: WidgetLayout, inline: boolean): string {
  const flags = getStyleFlags(layout, inline)
  const layoutStyles = getLayoutStyles(layout)
  return baseStyles(flags) + layoutStyles(flags)
}
